import angular from 'angular';
import { MdAutocompleteController } from './MdAutocomplete.controller';
import { NgEnterDirective } from './ngEnter.directive';
export var MdAutocompleteModule = angular
    .module('MdAutocomplete', [])
    .controller('MdAutocompleteController', MdAutocompleteController)
    .directive('ngEnter', NgEnterDirective)
    .name;
//# sourceMappingURL=MdAutocomplete.module.js.map